module.exports = __webpack_public_path__ + "media/images/riders/ALEXANDRA_ENGEN-e260bb1dfe0e0ba143f52085d46e175b.png";